import React, { useState } from 'react';
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import { FaInfoCircle, FaStar } from 'react-icons/fa';
import './Officemariscal.css';
import imagen1 from '../images/imagen4.png';
import imgsala1mar from '../images/log_mariscal.png'
import logoprinpag from '../images/logo6.png'
const Officemariscal = () => {
    const [ratings, setRatings] = useState([0, 0, 0]);
    const handleStarClick = (index, star) => {
        console.log(`Clicked star ${star} for index ${index}`);
        const newRatings = [...ratings];
        newRatings[index] = star;
        console.log('New ratings:', newRatings);
        setRatings(newRatings);
    };

    const items = [
        {
            image: imagen1,
            name: 'Oficina General',
            infoLink: '/office_mariscal',
        },
        {
            image: imgsala1mar,
            name: 'Oficina Privada',
            infoLink: '/office_mariscal',
        },
        {
            image: imagen1,
            name: 'Oficina de Reuniones',
            infoLink: '/office_mariscal',
        },
    ];

    return (
        <div>
            <Navbar />
            <div className="ofmas-container">
                <div className="ofmas-title" style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', alignItems: 'stretch', gap: '20px' }}>
                    <img src={logoprinpag} alt="Logoprinpag" style={{ height: '100%', objectFit: 'contain' }} />
                    <h2 className="card-title-office text-4xl font-bold" style={{ display: 'flex', alignItems: 'center' }}>
                        Mariscal Premium Offices
                    </h2>
                </div>


                <div className="gridmar">
                    {items.map((item, index) => (
                        <div key={index} className="cardmar">
                            <div className="content-container">
                                <img src={item.image} alt={item.name} className="item-image" />
                                <div className="item-info">
                                    <h3 className="item-name">{item.name}</h3>
                                    <div className="info-icon">
                                        <a href={item.infoLink} className="text-blue-500">
                                            <FaInfoCircle size={20} />
                                        </a>
                                    </div>
                                    <div className="stars-container">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <FaStar
                                                key={star}
                                                size={16}
                                                className={`cursor-pointer ${ratings[index] >= star ? 'text-yellow-500' : 'text-gray-300'}`}
                                                onClick={() => handleStarClick(index, star)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Officemariscal;
